import styled from 'styled-components';
import {GlobalFonts} from '../../globals';

export const ContImgMision = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;

  @media(min-width: 1px) and (max-width: 899px){
    & > img {
      display: none;
    }
  }
  @media(min-width: 900px) and (max-width: 1023px){
    & > img {
      width: 90%;
    }
  }
  @media(min-width: 1024px) and (max-width: 1079px){
    & > img {
      width: 100%;
    }
  }
  @media(min-width: 1080px) and (max-width: 1279px){
    & > img {
      width: 100%;
    }
  }
  @media(min-width: 1280px) and (max-width: 1407px){
    & > img {
      width: 100%;
    }
  }
  @media(min-width: 1408px) and (max-width: 1439px){
    & > img {
      width: 100%;
    }
  }
  @media(min-width: 1440px) and (max-width: 1919px){
    & > img {
      width: 100%;
    }
  }
  @media(min-width: 1920px){
    & > img {
      width: 100%;
    }
  }
`

export const ContInfoMisionVision = styled.div`
  position: relative;
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  
  @media(min-width: 300px) and (max-width: 767px){
    width: 90%;
    flex-direction: column;
    margin: 0 auto;
  }
  @media(min-width: 768px) and (max-width: 899px){
    width: 100%;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  @media(min-width: 900px) and (max-width: 1023px){
    width: 100%;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
  }
  @media(min-width: 1024px) and (max-width: 1079px){
    width: 90%;
  }
  @media(min-width: 1080px) and (max-width: 1279px){
    width: 95%;
  }
  @media(min-width: 1280px) and (max-width: 1407px){
    width: 95%;
  }
  @media(min-width: 1408px) and (max-width: 1439px){
    width: 93%;
  }
  @media(min-width: 1440px) and (max-width: 1919px){
    width: 95%;
  }
  @media(min-width: 1920px){
    width: 90%;
  }
`
export const CardTitle = styled.div`
  display: block;
  font-family: ${GlobalFonts.fontBold};
  text-align: left;
  color: #282828;
  @media(min-width: 300px) and (max-width: 767px){
    font-size: 30px;
    margin-top: 0; 
  }
  @media(min-width: 768px) and (max-width: 1023px){
    font-size: 30px;
    margin-top: 0;
    padding: 0;
  }
  @media(min-width: 1024px) and (max-width: 1079px){
    font-size: 38px;
    margin-top: 0;
    padding: 0;
  }
  @media(min-width: 1080px) and (max-width: 1279px){
    font-size: 38px;
    margin-top: 0;
    padding: 0;
  }
  @media(min-width: 1280px) and (max-width: 1407px){
    font-size: 38px;
    margin-top: 0;
    padding: 0;
  }
  @media(min-width: 1408px) and (max-width: 1439px){
    font-size: 38px;
    margin-top: 0;
    padding: 0;
  }
  @media(min-width: 1440px) and (max-width: 1919px){
    font-size: 38px;
    marginTop: 0; 
  }
  @media(min-width: 1920px){
    font-size: 38px;
    marginTop: 0; 
  }
`
export const CardTitleGray = styled.div`
  display: block;
  font-family: ${GlobalFonts.fontBold};
  text-align: left;
  color: #8F8F8F;
  @media(min-width: 300px) and (max-width: 767px){
    font-size: 30px;
    margin-top: 0; 
  }
  @media(min-width: 768px) and (max-width: 1023px){
    font-size: 30px;
    margin-top: 0;
    padding: 0;
  }
  @media(min-width: 1024px) and (max-width: 1079px){
    font-size: 38px;
    margin-top: 0;
    padding: 0;
  }
  @media(min-width: 1080px) and (max-width: 1279px){
    font-size: 38px;
    margin-top: 0;
    padding: 0;
  }
  @media(min-width: 1280px) and (max-width: 1407px){
    font-size: 38px;
    margin-top: 0;
    padding: 0;
  }
  @media(min-width: 1408px) and (max-width: 1439px){
    font-size: 38px;
    margin-top: 0;
    padding: 0;
  }
  @media(min-width: 1440px) and (max-width: 1919px){
    font-size: 38px;
    marginTop: 0; 
  }
  @media(min-width: 1920px){
    font-size: 38px;
    marginTop: 0; 
  }
`
export const CardDescription = styled.div`
  cursor: default;
  display: block;
  font-family: ${GlobalFonts.fontRegular};
  text-align: left;
  color: #4A4A4A;

  @media(min-width: 300px) and (max-width: 767px){
    font-size: 16px;
  }
  @media(min-width: 768px) and (max-width: 1023px){
    font-size: 16px;
  }
  @media(min-width: 1024px) and (max-width: 1079px){
    font-size: 18px;
  }
  @media(min-width: 1080px) and (max-width: 1279px){
    font-size: 18px;
  }
  @media(min-width: 1280px) and (max-width: 1407px){
    font-size: 18px;
  }
  @media(min-width: 1408px) and (max-width: 1439px){
    font-size: 18px;
  }
  @media(min-width: 1440px) and (max-width: 1919px){
    font-size: 18px;
  }
  @media(min-width: 1920px){
    font-size: 18px;
  }
`